module.exports = __webpack_public_path__ + "img/9788932316703.3f315b40.jpg";